<template>
  <div
    ref="imageAddModal"
    class="modal modal-v modal-v--mobile-fullscreen fade modal-add-image"
    id="imageAddModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="imageAddModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <ModalNavMobile></ModalNavMobile>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <form method="post" @submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="modal-body">
            <CropperComponent v-model="cropper" :open="open" @close="open = false" @loaded="loaded = $event"></CropperComponent>
            <!--            <div v-if="loaded" class="row">-->
            <!--              <div class="col-12">-->
            <!--                <div class="modal-edit-image__box-price">-->
            <!--                  <div class="checkbox-standard pull-left">-->
            <!--                    <label class="small-text">-->
            <!--                      <input v-model="form.paid" id="paid" name="paid" type="checkbox" class="form-control" value="1" />-->
            <!--                      <span class="checkbox-standard__box mr-2"></span>-->
            <!--                      {{ trans.get('profile:edit.add_image_modal.paid_photo') }}-->
            <!--                    </label>-->
            <!--                  </div>-->
            <!--                  <div id="price-input" class="form-inline modal-edit-image__set-price">-->
            <!--                    <input-->
            <!--                      v-model="form.price"-->
            <!--                      id="price"-->
            <!--                      name="price"-->
            <!--                      type="number"-->
            <!--                      class="input-number input-number__underline"-->
            <!--                      min="1"-->
            <!--                      max="200"-->
            <!--                      value="1"-->
            <!--                      :disabled="!form.paid"-->
            <!--                    />-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div v-if="loaded" class="d-flex flex-column justify-content-center align-items-center">
              <button type="submit" class="button button__fill mt-3 mb-2" :class="{ 'button__fill--disabled': processing }" :disabled="processing">
                {{ trans.get('profile:edit.add_image_modal.add_photo_button') }}
              </button>
              <button type="button" class="button button__link button__link--underline mb-3" data-dismiss="modal">
                {{ trans.get('profile:edit.add_image_modal.cancel_button') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ModalNavMobile from '../../../front/components/ModalNavMobile.vue';
import CropperComponent from '../../../front/components/User/CropperComponent';

export default {
  name: 'NewImageModal',
  components: { ModalNavMobile, CropperComponent },
  props: {},
  data() {
    return {
      open: false,
      loaded: false,
      cropper: null,
      processing: false,
      form: {
        avatar: false,
        price: null,
        paid: false,
      },
    };
  },
  computed: {},
  watch: {
    open(val) {
      if (val) {
        this.processing = false;
        $(this.$refs.imageAddModal).modal('show');
      } else {
        $(this.$refs.imageAddModal).modal('hide');
        this.$eventHub.$emit('FreshGallery');
      }
    },
  },
  methods: {
    submitForm: function (el) {
      let vm = this;
      const cropper = this.cropper;
      vm.processing = true;

      const cropperCanvas = cropper.getCroppedCanvas({
        width: 580,
        height: 800,
      });
      const cropperData = cropper.getData(true);

      cropperCanvas.toBlob(
        function (blob) {
          let croppedImage = document.createElement('img'),
            url = URL.createObjectURL(blob);
          croppedImage.onload = function () {
            // no longer need to read the blob so it's revoked
            URL.revokeObjectURL(url);
          };

          const form = new FormData(el.target);
          form.append('image_cropped_data', JSON.stringify(cropperData));
          axios
            .post(zRoute('ajax.user.media.store'), form)
            .then(function (response) {
              vm.processing = false;

              vm.open = false;
              vm.$emit('MediaStored');
            })
            .catch((error) => {
              vm.processing = false;

              vm.$notify({
                group: 'custom-template',
                type: 'error',
                title: 'Error',
                text: error.response.data.errors.image[0],
                duration: 5000,
                data: {},
              });
            });
        },
        'image/png',
        0.95
      ); // PNG at 95% quality
    },
  },
  mounted() {
    let vm = this;

    this.$eventHub.$on('NewImageModalOpen', () => {
      vm.open = true;
      const fileInput = $(vm.$refs.imageAddModal).find('input[type="file"]');

      fileInput.val('');
      fileInput.click();
    });

    $(this.$refs.imageAddModal).on('hidden.bs.modal', function () {
      vm.open = false;
    });
  },
};
</script>

<style scoped></style>
